'use client';
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import HeroSection from '@/components/common/HeroSection';
import PartnerLogos from './components/home/PartnerLogos';
import FeaturesSection from './components/home/FeaturesSection';
import OrderTour from './components/home/OrderTour';
import AiSolutionSection from './components/home/AiSolutionSection';
import FaqSection from './components/home/FaqSection';
import TeamSection from './components/home/TeamSection';
import VideoTutorialsSection from './components/home/VideoTutorialsSection';
import CtaSection from './components/home/CtaSection';
import { MdPhone } from 'react-icons/md';
import Button from '@/components/ui/Button';
import CalendlyModal from '@/components/ui/CalendlyModal';

// Reveal each section as it scrolls into view
function Reveal({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-120px' }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export default function Home() {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  const openCalendly = () => {
    if (typeof window !== 'undefined' && window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
    setIsCalendlyOpen(true);
  };

  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection
        title="The only complete solution in"
        highlightedText="Optical Industry"
        description="A complete Practice Management, E-Commerce, Electronic Medical Records, Remote Order Entry and Lab Management System on a common platform."
        backgroundImage="/images/hero.jpg"
      />
      {/* single continuous backdrop — no seams between sections */}
      <div className="relative z-10 bg-gradient-to-b from-white via-[#eef4fb] to-white">
        <main>
          {/* The hero ends on "Follow order #4821 through it", so the tour
              comes straight after it. Pinned scroll scene: never inside
              Reveal — a transformed ancestor would break ScrollTrigger's
              fixed pinning. */}
          <OrderTour id="how-it-works" />
          <Reveal>
            <PartnerLogos />
          </Reveal>
          <Reveal>
            <FeaturesSection id="why-us" />
          </Reveal>
          <Reveal>
            <AiSolutionSection />
          </Reveal>
          <Reveal>
            <VideoTutorialsSection />
          </Reveal>
          <Reveal>
            <FaqSection />
          </Reveal>
          <Reveal>
            <TeamSection />
          </Reveal>
          <CtaSection />
        </main>
        <div className="fixed bottom-6 right-6 z-[99999] block md:hidden">
          <Button
            variant="ghost"
            onClick={openCalendly}
            aria-label="Book a call"
            className="rounded-full flex items-center p-0 min-w-0 min-h-0 !bg-transparent !border-none !shadow-none"
          >
            <div className="bg-[#01a7ff] rounded-full w-[48px] h-[48px] flex items-center justify-center shadow-lg">
              <MdPhone size={24} color="#fff" />
            </div>
          </Button>
        </div>
        <Footer />
      </div>
      <CalendlyModal isOpen={isCalendlyOpen} onClose={() => setIsCalendlyOpen(false)} />
    </div>
  );
}
